import React, { useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'

import './styles.css'
import StoreContext from '../../components/storage/context';

// define um card grande para ser usado em um produto
const LargeCard = ({id, name, url, image}) => {
    // restaga o token obtido no contexto StoreContext
    const { setPKService } = useContext(StoreContext);

    let history = useHistory();

    const onClickCard = () => {
        setPKService(id)
        history.push({
            pathname: url,
            search: `?service_id=${id}`
        });
    }

    return (
        <div key={id} id={name} className="large-card-container" onClick={onClickCard}>
            <p className="large-card-description"></p>
            <h3 className="large-card-header">{name}</h3>
            <p className="large-card-link">Saiba mais</p>
            <img className="large-card-container-img" src={image} />
        </div>
    );
}

export default LargeCard;